module.exports = __webpack_public_path__ + "static/banner-bg-b145a981ad10eded22b6ab2b48b03a50.png";